import React from "react";
import { Paperclip, Download } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const fmtSize = (bytes) => {
  const b = Number(bytes) || 0;
  if (b >= 1024 * 1024) return `${(b / 1024 / 1024).toFixed(1)} MB`;
  if (b >= 1024) return `${(b / 1024).toFixed(0)} KB`;
  return `${b} B`;
};

/**
 * Renders a downloadable ticket attachment (file that arrived on the email).
 * Links to the authenticated GET /api/tickets/{ticketId}/attachments/{attId} endpoint.
 */
export const TicketAttachment = ({ ticketId, meta, createdAt, fmt }) => {
  const attId = meta?.id;
  const name = meta?.name || "attachment";
  const href = attId ? `${BACKEND_URL}/api/tickets/${ticketId}/attachments/${attId}` : null;
  return (
    <div
      className="rounded-lg border border-slate-200 bg-white p-3 flex items-center gap-3"
      data-testid={`ticket-attachment-${attId || "unknown"}`}
    >
      <div className="h-9 w-9 rounded-md bg-slate-100 flex items-center justify-center shrink-0">
        <Paperclip className="h-4 w-4 text-slate-500" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-slate-800 truncate">{name}</div>
        <div className="text-[11px] text-slate-400 font-mono">
          Attachment · {fmtSize(meta?.size)}{createdAt && fmt ? ` · ${fmt(createdAt)}` : ""}
        </div>
      </div>
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xs font-medium text-blue-700 hover:text-blue-900 px-2.5 py-1.5 rounded-md border border-blue-200 hover:bg-blue-50 shrink-0"
          data-testid={`download-attachment-${attId}`}
        >
          <Download className="h-3.5 w-3.5" /> Download
        </a>
      ) : (
        <span className="text-[11px] text-slate-400 italic shrink-0">unavailable</span>
      )}
    </div>
  );
};

export default TicketAttachment;
